module.exports = __webpack_public_path__ + "img/a3.745561f9.png";